import React from 'react';
import { LazyFeatureLoader } from './LazyFeatureLoader';

interface LazyTimeLapseProps {
  crop: string;
  posts: any[];
  onClose: () => void;
  trigger: React.ReactNode;
}

export const LazyTimeLapse = ({ crop, posts, onClose, trigger }: LazyTimeLapseProps) => {
  const timeLapseLoader = () => import('./TimeLapse').then(module => ({ 
    default: module.TimeLapse 
  }));

  return (
    <LazyFeatureLoader
      featureName="Time Lapse viewer"
      loader={timeLapseLoader}
      componentProps={{ crop, posts, onClose }}
      connectionBanner={true}
      onLoad={() => {
        console.log('🎬 TimeLapse module loaded for:', crop);
      }}
    >
      {trigger}
    </LazyFeatureLoader>
  );
};